import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentFactoryResolver, ViewEncapsulation, QueryList, ViewChildren, ChangeDetectorRef, EventEmitter, Input, AfterContentInit, AfterContentChecked, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IFormOptions, IFieldOptions, IEntityOptions, IFieldGroup, IFieldDef, IDataEndPoint, IActionOptions, ICustomActionOptions, IActionOptionDetail, IButton } from '@framework/interfaces/IEntity';
import { ApiService } from '@services/api/api.service';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
import { FormBuilderControl, IFormFieldGroup } from '@common/formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '@common/formbuilder/FormBuilderControlType';
import { Subscription } from '../../../../../node_modules/rxjs';
import { IButtonAction } from '../mf-blade/mf-blade.component';
import { IdentityAuthService, IPermissionWithRights } from '../../../services/identity-auth/identity-auth.service';
import { ToastrService } from 'ngx-toastr';
import { FieldType, ActionType, ViewType } from '../../core/Enums';
import { ToolbarActionsService, ToolbarActionType, IToolbarAction } from '../../../services/toolbar-actions/toolbar-actions.service';
import { NgForm, UntypedFormGroup, FormControl } from '@angular/forms';
import { MfFormFieldsComponent } from '../mf-form-fields/mf-form-fields.component';
import { MfControlPopupComponent } from '../mf-control-popup/mf-control-popup.component';
import { TdDialogService } from '@covalent/core/dialogs';
import { NestedNavigationService } from '../../../services/nested-navigation/nested-navigation.service';
import { IPermissionConfig } from '../../app';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import * as _ from 'underscore';
import { SharedFiltersService } from '../../../services/shared-filters/shared-filters.service';
import { MatDialog } from '@angular/material/dialog';

export interface IDetailPageComponentTab {
  displayName: string;
  tab: any;
  isHidden?: boolean;
}

@Component({
  selector: 'app-mf-generated-form',
  templateUrl: './mf-generated-form.component.html',
  //styleUrls: ['@framework/components/mf-generated-form/mf-generated-form.component.css']
})
export class MfGeneratedFormComponent implements OnInit, OnDestroy {
  @ViewChild('tabDetail', { static: true }) tabDetail: ViewContainerRef;
  @ViewChild('htmlForm', { static: true }) htmlForm: NgForm;
  public get unsavedChanges() {
    return this.canSave && this.htmlForm.dirty && !this.htmlForm.pristine;
  }

  @ViewChildren('tabDetails', { read: ViewContainerRef }) public tabDetails: QueryList<ViewContainerRef>;

  private _subscriptions: Array<Subscription> = new Array<Subscription>();
  private _newItem: boolean = false;
  private _form: IFormOptions;
  private _forms: Array<IFormOptions>;
  private _formFields: Array<FormBuilderControl> = new Array<FormBuilderControl>();
  private tabInstances: any;
  private _loading: boolean = false;

  protected detailPageComponentForm: IFormOptions;
  protected detailPageComponentTabs: Array<IDetailPageComponentTab>;
  protected identifierProperty: string;
  protected loadWithoutParams: boolean = false;

  protected _canSave: boolean = true;
  protected _entityId: any;


  public instanceEntityId: any;
  //public get instanceEntityId() { return this._instanceEntityId }
  //public set instanceEntityId(val) { debugger; this.entityId = val; this._instanceEntityId = val; }
  public get form(): IFormOptions {
    if (!this._form) {
      this._form = this.detailPageComponentForm ? this.detailPageComponentForm : (this.entityOptions ? this.entityOptions.form : { name: "" })
    }
    return this._form;
  };
  public get groupsAreAccordions() {
    return this.form.groupsAreAccordions;
  }
  public get groupsAreTabs() {
    return this.form.groupsAreTabs;
  }
  public get groupsAreMasterDetail() {
    return this.form.groupsAreMasterDetail;
  }

  public get forms(): Array<IFormOptions> { return this.entityOptions ? this.entityOptions.forms : null };
  public get tabs(): Array<IDetailPageComponentTab> { return this.detailPageComponentTabs };
  public get doNotLoadOnEntity(): boolean { return this.entityOptions ? this.entityOptions.doNotLoadOnEntity : false };
  public get newItem(): boolean { return this._newItem };
  public get entityId() { return this._entityId };
  public formClass: string = '';
  public entityIdChange = new EventEmitter()
  public set entityId(value) {
    //if (value == null)
    //  return;
    this.entityIdChange.emit();
    if (this._entityId == "00000000-0000-0000-0000-000000000000" && this._entityId != value)
      this.newlyAddedItemLoaded = true;


    this._entityId = value;
    this.reset();
    if (value == "00000000-0000-0000-0000-000000000000") {
      this.addNew();

      this.calcHeader();
    }
    else this.loadEntity();
  }
  public get header(): string {
    return this.entityData
      ? this._forms[0].displayName
        ? this.entityData[this._forms[0].displayName]
        : null
      : null
  };
  public get canSave() {
    return this._canSave && !this.formReadonly;
  }
  public get canDelete() {
    return !this.newItem && this._form && this._form.canDelete && !this.formReadonly;
  }
  public set canSave(value) { this._canSave = value };
  public get saveActionButton() {
    var action = this.toolbarActionsService.items.filter(o => {
      return o.nestedFormId == this.listIndex && o.formId == this.parent.formIndex && o.identifier == "save";
    })
    if (action.length > 0) return action[0];
  }
  public get loading() {
    return this._loading;
  };
  public set loading(value) {
    this._loading = value;
    if (this.saveActionButton) this.saveActionButton.disabled = value;
  };

  public actionType = ToolbarActionType;
  public fieldGroups: Array<IFormFieldGroup>;
  public formFields: Array<FormBuilderControl>;
  public buttonActions: Array<IButtonAction> = new Array();
  public setParentBladeLoading: boolean;
  public isHidden: boolean = false;
  public listIndex: any;
  public formReadonly: boolean;
  public initialized: boolean = false;
  public entityOptions: IEntityOptions;
  public tabViews: Array<any>;
  public loadedEntityId: any;
  public entityData: any = {};
  public isDialog: boolean = false;
  public hidden: boolean = false;
  public newlyAddedItemLoaded: boolean;
  public parent: any;
  public activeIndex: number = 0;
  public processingControls: boolean;
  public formActions?: Array<IButton> = new Array<IButton>(); public dialogRef?: any;

  constructor(public apiService?: ApiService, public route?: ActivatedRoute, private componentFactoryResolver?: ComponentFactoryResolver,
    public messageService?: ToastrService, public authService?: IdentityAuthService, public confirmationService?: ConfirmationService,
    public dynamicDialogConfig?: DynamicDialogConfig, public cdr?: ChangeDetectorRef, public toolbarActionsService?: ToolbarActionsService, public dialogService?: TdDialogService,
    public nestedNavigationService?: NestedNavigationService, private sharedFiltersService?: SharedFiltersService,
    public dialog?: MatDialog) {
  }

  private async processFormControls() {
    let self: MfGeneratedFormComponent = this,
      fieldGroups: Array<IFormFieldGroup> = new Array<IFormFieldGroup>(),
      actions: Array<IActionOptions> = new Array<IActionOptions>();
    self.processingControls = true;
    await self.authService.ensureAppSettingsLoaded();

    self._forms.forEach((form, index) => {
      let itemDTO: IEntityModel = form.model ? form.model : this.entityOptions && this.entityOptions.model ? this.entityOptions.model : null;

      let fields: Array<IFieldOptions> = _.filter(form.fields, el => { return self.authService.canViewField(form.name, el.field) && !el.exclude })
        .filter((i, f) => {
          let field: IFieldOptions = (<IFieldOptions>f);
          if (!field.permissions) return true;
          return field.permissions.filter(p => {
            let permissions: Array<IPermissionConfig> = new Array<IPermissionConfig>();
            permissions.push({ permissions: p.permissions });
            return self.authService.hasAnyPermissionsArr(permissions)
          }).length > 0;
        });
      let formFields = fields
        .map(field => {
          let control = new FormBuilderControl();
          let itemDTOField: IEntityModelField = form.model && form.model.fields && form.model.fields[field.field] ? form.model.fields[field.field] : this.entityOptions && this.entityOptions.model ? this.entityOptions.model.fields[field.field] : null;
          let displayName: string = self.authService.fieldLabelName(form.name, field.field);
          let groupName: string = self.authService.fieldGroupName(form.name, field.field);
          if (displayName) field.name = displayName;
          if (groupName) field.group = groupName;
          self.authService.extendedSettings(form.name, field.field).forEach(s => {
            if (s.name.indexOf(".") == -1) field[s.name] = s.value ? s.value : null
            else {
              let obj = field,
                names = s.name.split("."),
                namesLength = names.length - 1;
              names.forEach((n, i) => { if (i < namesLength) obj = obj[n] ? obj[n] : obj[n] = {} });
              obj[names[namesLength]] = s.value ? s.value : null;
            }
          });
          if (field.readOnly != undefined) {
            let fieldReadOnly = field.readOnly;
            field.readOnly = function () {
              if (!self.canSave) return true;
              return typeof fieldReadOnly == 'function' ? fieldReadOnly(self.entityData, self, field) : fieldReadOnly;
            }
          }
          else {
            field.readOnly = function () {
              return !self.canSave;
            }
          }
          fields[form.name + "_" + field.field] = field;
          control.load(field, itemDTO, itemDTOField);
          return control;
        });
      formFields.forEach(ff => {
        self._formFields[form.name + "_" + ff.field] = ff;
        self._formFields.push(self._formFields[form.name + "_" + ff.field]);
      });
      if (form && form.fields) {
/*        form.fields.forEach(field => {
          let displayName: string = self.authService.fieldLabelName(form.name, field.field);
          if (displayName) { debugger; field.name = displayName; }
        });
*/        if (form.groups && form.groups.length > 0) {
          form.groups.forEach(g => {
            let fieldGroup: IFormFieldGroup = fieldGroups[g.name] = g;
            if (!fieldGroup.className) fieldGroup.className = "col-lg-12";
            fieldGroups.push(fieldGroup);
            if (!g.fields) g.fields = new Array<IFieldDef>();
            _.filter(form.fields, f => f.group && f.group == g.name).forEach(f => {
              let fieldDef: IFieldDef = <IFieldDef>f;
              fieldDef.formField = f;
              g.fields.push(fieldDef);
            });
          });
        }
        let formGroupFields: Array<IFieldOptions> = _.filter(_.filter(form.fields, f => f.group != undefined), f => fieldGroups && (!fieldGroups[f.group] || _.filter(fieldGroups[f.group].fields, fg => fg.field == f.field).length == 0));
        formGroupFields.forEach(f => {
          if (!fieldGroups) fieldGroups = new Array<IFormFieldGroup>();
          let fieldGroup: IFormFieldGroup = fieldGroups[f.group];
          if (!fieldGroup) {
            fieldGroup = fieldGroups[f.group] = { name: f.group, displayName: f.group, frame: true, className: form.className ? form.className : "col-lg-12", fields: new Array<IFieldDef>() };
            fieldGroups.push(fieldGroup);
          }
          let fieldDef: IFieldDef = <IFieldDef>f;
          fieldDef.formField = f;
          fieldGroup.fields.push(fieldDef);
        });
        let formGroupName = self.authService.fieldGroupName(form.name, form.name);
        if (formGroupName) form.group = formGroupName;
        if (form.group) {
          _.filter(form.fields, f => !f.group).forEach(f => {
            if (!fieldGroups) fieldGroups = new Array<IFormFieldGroup>();
            let fieldGroup: IFormFieldGroup = fieldGroups[form.group];
            if (!fieldGroup) {
              fieldGroup = fieldGroups[form.group] = { name: form.group, displayName: form.group, frame: true, fields: new Array<IFieldDef>(), className: form.className ? form.className : "col-lg-12" };
              fieldGroups.push(fieldGroup);
            }
            let fieldDef: IFieldDef = <IFieldDef>f;
            fieldDef.formField = f;
            fieldGroup.fields.push(fieldDef);
          })
        }
      }
      if (fieldGroups) fieldGroups.forEach(fieldGroup => {
        if (fieldGroup.fields && fieldGroup.fields.length > 0) {
          if (!fieldGroup.formFields) fieldGroup.formFields = new Array<FormBuilderControl>();
          _.filter(fieldGroup.fields, f => { return fields[form.name + "_" + f.field] && _.filter(fieldGroup.formFields, ff => ff.fieldOptions.dbField == f.formField.dbField).length == 0 ? true : false }).forEach(f => { fieldGroup.formFields.push(self._formFields[form.name + "_" + f.field]) });
        }
      })
      if (form.actions) {
        form.actions.forEach(act => {
          if (act.type != ActionType.Custom) actions.push(act);
          else if (act.type == ActionType.Custom) act.custom.actions.forEach(cst => { if (cst.formButton) actions.push(cst) })
        })
      }
    });
    if (fieldGroups && fieldGroups.length > 0) {
      self.fieldGroups = fieldGroups;
      //self.formFields = new Array();
      //self.fieldGroups.forEach(o => {
      //  o.formFields.forEach(ff => {
      //    self.formFields.push(ff);
      //  })
      //})
    }
    else {
      self.formFields = self._formFields;
    }
    self.processingControls = false;
    if (self.fieldGroups) {
      self.fieldGroups.forEach(grp => {
        if (grp.formFields) {
          var nestedControls = grp.formFields.filter(field => (<any>field).fieldOptions?.nestedControlParentId);
          nestedControls.forEach(nestedControl => {
            var parentControl = grp.formFields.filter(field => field.field == (<any>nestedControl).fieldOptions?.nestedControlParentId);
            if (parentControl.length == 0) {
              console.log('cannot find nestedParentControlId: ' + (<any>nestedControl).fieldOptions?.nestedControlParentId)
            }
            else {
              var ff = (<any>parentControl[0]);
              if (!ff.nestedControls)
                ff.nestedControls = new Array();
              ff.nestedControls.push(nestedControl);
              grp.formFields.splice(grp.formFields.indexOf(nestedControl), 1);
            }
          })
        }
      })

    }
    if (self.formFields) {
      var nestedControls = self.formFields.filter(field => (<any>field).fieldOptions?.nestedControlParentId);
      nestedControls.forEach(nestedControl => {
        var parentControl = self.formFields.filter(field => field.field == (<any>nestedControl).fieldOptions?.nestedControlParentId);
        if (parentControl.length == 0) {
          console.log('cannot find nestedParentControlId: ' + (<any>nestedControl).fieldOptions?.nestedControlParentId)
        }
        else {
          var ff = (<any>parentControl[0]);
          if (!ff.nestedControls)
            ff.nestedControls = new Array();
          ff.nestedControls.push(nestedControl);
          self.formFields.splice(self.formFields.indexOf(nestedControl), 1);
        }
      })
    }

    if (self.entityOptions && self.entityOptions.actions) {
      self.entityOptions.actions.forEach(act => {
        if (act.type != ActionType.Custom) actions.push(act);
        else if (act.type == ActionType.Custom) act.custom.actions.forEach(cst => { if (cst.formButton) actions.push(cst) })
      })
    }
    if (!this.form.hideClose) {
      //<button[hidden]="form?.hideClose" mat - raised - button color = "default"(click) = "cancel()" > <mat-icon > close < /mat-icon> Cancel</button >
      actions.push({ type: ActionType.Cancel, name: "Cancel", title: "Close", color: 'default', displayName: "Cancel", isButton: true })
    }

    actions.filter(a => !a.tab).forEach((act, idx) => {
      let frmbtn: IActionOptionDetail = (<ICustomActionOptions>act).formButton;
      let displayName: string = self.authService.fieldLabelName(self.form.name, frmbtn && frmbtn.name ? frmbtn.name : act.name);
      let btn: IButton = {
        name: frmbtn && frmbtn.name ? frmbtn.name : act.name,
        displayName: displayName ? displayName : frmbtn && frmbtn.displayName ? frmbtn.displayName : act.displayName,
        icon: frmbtn && frmbtn.icon ? frmbtn.icon : act.icon,
        className: frmbtn && frmbtn.className ? frmbtn.className : act.className,
        color: act.color,
        get disabled(): boolean {
          //if (!formValid) return true;
          if (frmbtn && frmbtn.disabled != undefined) return typeof frmbtn.disabled == 'function' ? frmbtn.disabled(self.entityData, self) : frmbtn.disabled;
          if (act.disabled) return typeof act.disabled == 'function' ? act.disabled(self.entityData, self) : act.disabled;
          return false;
        },
        get show(): boolean {
          if (act.type == ActionType.Save && !self.canSave) return false;
          if (act.type == ActionType.Delete && (self.newItem || self.formReadonly)) return false;
          if (frmbtn && frmbtn.show != undefined) return typeof frmbtn.show == 'function' ? frmbtn.show(self.entityData, self) : frmbtn.show;
          if (act.show) return typeof act.show == 'function' ? act.show(self.entityData, self) : act.show;
          return true;
        },
        action: function () {
          if (frmbtn && frmbtn.action) {
            frmbtn.action(self, self.entityData);
          }
          else if (act.action) {
            act.action(self, self.entityData);
          }
          else if (act.type == ActionType.Save) {
            self.save();
          }
          else if (act.type == ActionType.Delete) {
            self.delete();
          }
          else if (act.type == ActionType.Cancel) {
            self.cancel();
          }
        }
      };
      if (act.type == ActionType.Save) {
        btn.displayName = displayName ? displayName : act.displayName ? act.displayName : "Save";
        btn.icon = act.icon ? act.icon : "save";
        btn.className = act.className ? act.className : "mf-button-save";
        if (!btn.color) btn.color = 'accent';
      }
      if (act.type == ActionType.Delete) {
        btn.displayName = displayName ? displayName : act.displayName ? act.displayName : "Delete";
        btn.icon = act.icon ? act.icon : "remove_circle";
        if (!btn.color) btn.color = 'warn';
      }
      var hasPermissions = true;
      if (act.permissions && act.permissions.length > 0) {
        if (!self.authService.hasAnyPermissionsArr(act.permissions)) hasPermissions = false;
      }
      var toolbarAction: IToolbarAction = { formId: self.parent.formIndex, nestedFormId: self.listIndex, command: function () { btn.action() }, icon: btn.icon, label: btn.displayName, type: ToolbarActionType.Button, identifier: btn.name, sortOrder: idx };
      if (act.type == ActionType.Save)
        toolbarAction.hidden = function () {
          let hidden: Function | boolean = !self.canSave;
          if (!hidden) hidden = !btn.show;
          return hidden;
        };
      if (act.type == ActionType.Delete)
        toolbarAction.hidden = function () {
          let hidden: Function | boolean = !self.canSave || !self.canDelete;
          if (!hidden) hidden = !btn.show;
          return hidden;
        };
      else toolbarAction.hidden = function () { return !btn.show; };

      if (act.type == ActionType.Delete) {
        toolbarAction.buttonType = 'warn';
        if (self.canDelete == false)
          hasPermissions = false;
      }
      if (act.type == ActionType.Cancel)
        toolbarAction.buttonType = 'default';
      if (act.type == ActionType.Save && !hasPermissions) self.canSave = false;
      if (hasPermissions && act.type != ActionType.Cancel) self.toolbarActionsService.addItem(toolbarAction);
      if (frmbtn && frmbtn.hideOnForm) {
      }
      else if (hasPermissions) self.formActions.push(btn);
    });
    var dirty = {
      formId: self.parent.formIndex, nestedFormId: self.listIndex, icon: ['fal', 'pen'], iconColor: "orange", tooltip: "Unsaved changes", hidden: function () { return !self.htmlForm.dirty }, label: "", type: ToolbarActionType.IconButton, identifier: "dirty", sortOrder: -1
    }
    self.toolbarActionsService.addItem(dirty);
    //self.htmlFormGroup.markAllAsTouched();
  }
  public getFormInstanceByIndex(index) {
    return this.parent.getFormInstanceByIndex(index);
  }
  public reloadFormByIndex(index) {
    return this.parent.reloadFormByIndex(index);
  }
  private buildTabs() {
    this.tabInstances = new Array();
    for (let i = 0; i < this.tabDetails.toArray().length; i++) {
      let component = this.detailPageComponentTabs[i];
      if (component) {
        let target = this.tabDetails.toArray()[i];
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.tab);
        let componentRef: any = target.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.entity = component.tab;
        _component.entity.component = _component;
        _component.parent = this;
        this.tabInstances.push(_component);
      }
    }
  }

  public flattenObj(obj, parent, res = {}) {
    for (let key in obj) {
      var skip = false;
      if (this.form.skipUnflattenProperties) {
        this.form.skipUnflattenProperties.forEach(o => {
          if (key.indexOf(o) != -1)
            skip = true;
        })
      }
      if (!skip) {
        let propName = parent ? parent + '___' + key : key;
        if (typeof obj[key] == 'object') {
          this.flattenObj(obj[key], propName, res);
        } else {
          res[propName] = obj[key];
        }
      }
      else {

      }
    }
    return res;
  }
  private setValue(obj, access, value) {

    if (typeof (access) == 'string')
      access = access.split('___');



    if (access.length > 1) {
      if (obj) {
        if (!obj[access[0]]) {
          obj[access[0]] = {};
        }
        this.setValue(obj[access.shift()], access, value);
      }
    } else {
      if (obj)
        obj[access[0]] = value;
    }
  }

  private unflatten(flattened) {
    var data = flattened;
    for (let key in flattened) {
      var skip = false;

      if (!skip) {
        if (key.indexOf("___") != -1) {
          if (key.indexOf("__history") == -1) {
            this.setValue(data, key, flattened[key]);
            delete data[key];
          }
        }
      }
    }

    return data;
  }

  public async load() {
    let self: MfGeneratedFormComponent = this;
    self.initialized = true;
    if (self.entityOptions) {
      if ((typeof self.entityOptions.loadOnlyOnEntity != "undefined" && !self.entityOptions.loadOnlyOnEntity)) {
        self.entityId = "0";
        self.loadWithoutParams = true;
      };
    }
    else if (self.loadWithoutParams) {
      self.entityId = "0"
    };



    self._forms = self.forms;


    if (!self._forms && self.form) {
      self._forms = new Array<IFormOptions>();
      self._forms.push(self.form);


    }
    else if (!self.form) {
      self._form = self.forms[0];
    }


    await self.processFormControls();
    if (self.parent && self.parent.entityIdChange) {
      self.entityId = self.parent.entityId;
      self.parent.entityIdChange.subscribe(entityId => {
        self.entityId = entityId;
      })
    }
    else {
      self._subscriptions.push(
        self.route.params.subscribe(params => {
          self.entityId = params['id'];
        })
      );
    }
    if (self.dialogRef) {
      if (self.dynamicDialogConfig && self.dynamicDialogConfig.data) {
        self.parent = self.dynamicDialogConfig.data.parent;
        self.entityId = self.dynamicDialogConfig.data.entityId ? self.dynamicDialogConfig.data.entityId : "00000000-0000-0000-0000-000000000000"
        self._newItem = self.entityId == "00000000-0000-0000-0000-000000000000"
      }
      if (!self.instanceEntityId)
        self.addNew();
      else self.entityId = self.instanceEntityId;
    }
  }
  public loadEntity(force?: boolean, loadEmptyNew?: boolean) {
    var differentEntityId = true;
    if (force)
      this.reset();
    let self: MfGeneratedFormComponent = this;
    if (self.doNotLoadOnEntity) {

      self.entityData = {};
      return;
    }
    if (!self.loadWithoutParams && ((!self.entityId && self.entityId != "0") || self.newItem)) {
      return;
    }
    if (self.setParentBladeLoading) self.parent.loading = true;
    self.loading = true;
    let dataEndPoint: IDataEndPoint =
      self.entityOptions && self.entityOptions.dataEndPoint
        ? self.entityOptions.dataEndPoint
        : self._form && self._form.dataEndPoint
          ? self._form.dataEndPoint
          : null;
    if (!dataEndPoint)
      if (self.entityOptions?.form?.dataEndPoint)
        dataEndPoint = self.entityOptions?.form?.dataEndPoint;
    if (dataEndPoint)
      self.apiService.exec({
        endPoint: dataEndPoint,
        context: self,
        success: function (data) {
          if (self.loadedEntityId == data?.id)
            differentEntityId = false;
          self.loadedEntityId = data?.id;

          if (self.form && self.form.onLoadProcessData)
            data = self.form.onLoadProcessData(self, data);
          self.entityData = self._newItem ? {} : self.flattenObj(data, null, data);
          self.loading = false;
          self.calcHeader();
          self.buttonActions = new Array();
          self._forms.forEach(form => { if (form.onLoaded) form.onLoaded(self, self.entityData, differentEntityId); });
          if (self.entityOptions && self.entityOptions.onLoaded) self.entityOptions.onLoaded(self, self.entityData, differentEntityId);
          self.entityData = self.flattenObj(self.entityData, null, self.entityData);
          self.parent.buildMenus(self.entityData, false, self.listIndex, self)
          if (self.parent.onFormLoad) self.parent.onFormLoad(self.entityData, self.listIndex, self)
          if (self.setParentBladeLoading) self.parent.loading = false;
          if (self.newlyAddedItemLoaded) self.newlyAddedItemLoad();
          if (loadEmptyNew)
            self._newItem = true;

          //var disabledCache = self.formFields.filter(o => { return (o.fieldOptions && o.fieldOptions.disableLookupCache) || o.disableLookupCache });
          //debugger;
          //if (disabledCache.length > 0) {
          //  disabledCache.forEach(o => {
          //    debugger;
          //    o.formControl.setupDropdowns();
          //  })
          //}
        },
        error: function (error) {
          self.loading = false;
          self.messageService.error('error', 'Could not load');
        }
      })
    else self.loading = false;
  }
  public calcHeader() {
    if (this.listIndex != 0)
      return; //Only first tab can set header
    if (this.entityOptions) {
      var displayField: any = this.entityOptions.displayField;
      var displayValue: any = this.entityOptions.displayValue;
      var data = this.entityData;
      var breadcrumbLabel = '';
      if (this.entityOptions.displayField) {
        if ({}.toString.call(displayField) === '[object Function]') {
          if (data)
            breadcrumbLabel = data[displayField(data)];
        }
        else {
          if (typeof data)
            breadcrumbLabel = data[displayField]?.toString();
        }
      }

      if (this.entityOptions.displayValue) {
        if ({}.toString.call(displayValue) === '[object Function]') {
          breadcrumbLabel = displayValue(data);
        }
        else {
          breadcrumbLabel = displayValue;
        }
      }
      //if (breadcrumbLabel != '') {
      //  var breadCrumb = this.breadCrumbService.breadcrumbs.filter(o => {
      //    return o.id == this.formIndex
      //  });
      //  if (breadCrumb.length > 0)
      //    breadCrumb[0].label = breadcrumbLabel;
      //}
      //if (this.nestedNavigationService.routeParams.listIndex == this.parent.parent.CurrentIndex) {

     
      if (this.parent && this.parent.header)  this.parent.headerIdentifier = breadcrumbLabel;

      if (this.form && this.form.subTitle) {
        var headerFilt = this.nestedNavigationService.headers.filter(o => o.listIndex == this.parent.formIndex);
        var header: any = null;
        if (headerFilt.length == 0) {
          header = { listIndex: this.parent.formIndex }
          this.nestedNavigationService.headers.push(header);
        }
        else header = headerFilt[0]


          if (this.form.subTitleStyling)
            if ({}.toString.call(this.form.subTitleStyling) === '[object Function]') {
              header.subTitleStyling = this.form.subTitleStyling(data);
            }
            else {
              header.subTitleStyling = this.form.subTitleStyling;
            }

          if ({}.toString.call(this.form.subTitle) === '[object Function]') {
            header.subTitle = this.form.subTitle(data);
          }
          else {
            header.subTitle = this.form.subTitle;
          }
      }
      //}
    }
  }

  public markFormGroupTouched(formgroup: UntypedFormGroup) {
    if (!formgroup)
      return;
    (<any>Object).values(formgroup.controls).forEach(control => {
      control.markAsTouched();
      control.updateValueAndValidity();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public resetFormGroup(formgroup: UntypedFormGroup) {
    if (!formgroup)
      return;
    (<any>Object).values(formgroup.controls).forEach(control => {
      control.markAsUntouched();
      control.markAsPristine();
      if (control.controls) {
        this.resetFormGroup(control);
      }
    });
  }

  public getFormControl(name) {
    if (this.htmlForm) {
      //this.htmlForm.form.markAllAsTouched()
      var group = (<any>this.htmlForm.form.controls.control)
      if (group)
        return group.controls[name];
    }
    else return null;
  }
  public setMultiInstanceFields(data) {
    var groups: any = this.fieldGroups;
    if (!this.fieldGroups)
      groups = [{ formFields: this.formFields }]
    groups.forEach(g => {
      var multiInstanceFields = _.filter(g.formFields, o => o.controlType.viewType == ViewType.MultipleInstance);
      multiInstanceFields.forEach(o => {
        if (data[o.field]) {
          data[o.field].forEach(i => {
            if (i.data) {
              Object.keys(i.data).forEach(k => {
                i[k] = i.data[k];
              })
            }
          })
          var flattenedToRemove = Object.keys(data).filter(key => {
            //get flattened data
            return key.indexOf(o.field) != -1 && key != o.field
          })
          flattenedToRemove.forEach(u => {
            delete data[u];
          })
        }
      })


    })
  }

  public async save(doNotCloseBlade?: boolean, navigateToNewIndex?: number, overrideValidate?: boolean) {
    let self: MfGeneratedFormComponent = this;

    if (!await self.anyControlBlockingSave()) {
      await new Promise(resolve => setTimeout(resolve, 100));
      if (!await self.anyControlBlockingSave(true))
        return;
    }
    if (self.anyValidationIssues()) {
      self.messageService.error('Not all fields could be validated. Please review values highlighted in red', 'Could not save', {
        timeOut: 6000
      });
      return;
    }

    if (this.htmlForm) {
      //this.htmlForm.form.markAllAsTouched()
      var group = (<any>this.htmlForm.form.controls.control)
      this.markFormGroupTouched(group);
    }
    var savedWithValidationFailed = false;
    debugger;
    if (!self.validateRequiredFields()) {
      if (self.entityOptions && self.entityOptions.allowSaveWithoutAllCompulsory) {
        self.dialogService.openAlert({
          message: 'You may not be able to complete the form until all required fields are captured.',
          disableClose: true, // defaults to false
          title: 'Not all required fields are captured.', //OPTIONAL, hides if not provided
          closeButton: 'Close', //OPTIONAL, defaults to 'CLOSE'
        });
        savedWithValidationFailed = true;
      }
      else {
        self.messageService.error('Not all required fields were captured. Please review values highlighted in red', 'Could not save', {
          timeOut: 6000
        });
        return;
      }
    }

    this.setMultiInstanceFields(self.entityData);

    var data = Object.assign({}, self.entityData);
    data = self.unflatten(data);

    if (self._form.customValidation) {
      var valid = await self._form.customValidation(data, self.entityOptions, self.authService, self);
      if (!valid)
        return;
    }

    if (self.entityOptions && self.entityOptions.transFormDataForSave) {
      data = await self.entityOptions.transFormDataForSave(data, self.entityOptions, self.authService, self);
    }
    else if (self._form.transFormDataForSave) {
      data = await self._form.transFormDataForSave(data, self.entityOptions, self.authService, self);
    }

    if (self.newItem) {
      self.saveNew(data);
      return;
    }
    self.loading = true;
    self.nestedNavigationService.loading = true;
    let updateEndPoint: IDataEndPoint =
      self.entityOptions && self.entityOptions.endPoints && self.entityOptions.endPoints.update
        ? self.entityOptions.endPoints.update
        : self.form && self._form.endPoints && self._form.endPoints.update
          ? self._form.endPoints.update
          : null;
    if (updateEndPoint)
      self.apiService.exec({
        endPoint: updateEndPoint,
        data: data,
        context: self,
        success: function (data) {
          self.loading = false;

          self.nestedNavigationService.loading = false;
          if (self.dialogRef) self.dialogRef.close(data);
          if (self.parent && self.parent.onBladeSave) self.parent.onBladeSave(self);
          if (self.entityOptions && self.entityOptions.onSaveComplete) self.entityOptions.onSaveComplete(self, data);
          if (self.forms && self.forms.length > 0) {
            self.forms.forEach(f => {
              if (f.onSaveComplete) f.onSaveComplete(self, data);
            })
          }
          else if (self.form && self.form.onSaveComplete) self.form.onSaveComplete(self, data);
          //if (self.parent && self.parent.closeBlade)
          //if (!doNotCloseBlade) {
          //  self.parent.closeBlade();
          //  
          //}
          //else
          if (self.htmlForm) {
            //self.htmlForm.dirty = false;
            var group = (<any>self.htmlForm.form.controls.control)
            self.resetFormGroup(group);
          }

          if (self.entityId == "00000000-0000-0000-0000-000000000000" && self.entityData.id != "00000000-0000-0000-0000-000000000000")
            self.parent.navigateToIndex(self.parent.formIndex, self.entityData.id);
          else self.loadEntity();
          if (self.parent && self.parent.loadData)
            self.parent.loadData();
          if (self.parent && self.parent.selectedItem)
            self.parent.selectedItem = null;
          self.messageService.success('Saved successfully', 'Action');
          self.parent.refreshRelatedLists(self.entityOptions.name, self.entityId);
          if (navigateToNewIndex && self.parent)
            self.parent.selectedMenuItemIndex = navigateToNewIndex;

          if (savedWithValidationFailed)
            if (self.htmlForm) {
              //this.htmlForm.form.markAllAsTouched()
              var group = (<any>self.htmlForm.form.controls.control)
              self.markFormGroupTouched(group);
            }
          if (((typeof self.form.closeBladeOnSave == "undefined" && self.parent.detailComponents.length == 1) || self.form.closeBladeOnSave) && self.parent && self.parent.closeBlade)
            self.parent.closeBlade();

        }, error: function (error) {
          self.nestedNavigationService.loading = false;
          self.loading = false;

          if (error.status == 401)
            self.messageService.error('Insufficient permissions', 'Could not save');
          else self.messageService.error((error && error.error ? error.error : ''), 'Could not save');
        }
      });

  }
  public saveNew(data) {
    let self: MfGeneratedFormComponent = this;
    self.loading = true;
    self.nestedNavigationService.loading = true;
    let insertEndPoint: IDataEndPoint =
      self.entityOptions && self.entityOptions.endPoints && self.entityOptions.endPoints.insert
        ? self.entityOptions.endPoints.insert
        : self.form && self._form.endPoints && self._form.endPoints.insert
          ? self._form.endPoints.insert
          : null;
    if (insertEndPoint)
      self.apiService.exec({
        endPoint: insertEndPoint,
        data: data,
        context: self,
        success: function (item) {
          self.loading = false;
          self.nestedNavigationService.loading = false;
          self.messageService.success('Created successfully', 'Action');
          if (!self.dialogRef && self.parent && self.parent.navigateToIndex)
            self.parent.navigateToIndex(self.parent.formIndex, item.id ? item.id : item);
          if (self.parent && self.parent.onBladeSave)
            self.parent.onBladeSave(self);
          if (self.dialogRef)
            self.dialogRef.close(item)
          if (self.parent && self.parent.selectedItem)
            self.parent.selectedItem = null;
          if (self.htmlForm) {
            //self.htmlForm.dirty = false;
            var group = (<any>self.htmlForm.form.controls.control)
            self.resetFormGroup(group);
          }
          self.parent.refreshRelatedLists(self.entityOptions.name, item.id ? item.id : item);
          if (self.entityOptions && self.entityOptions.onSaveComplete) self.entityOptions.onSaveComplete(self, item);
          if (self.forms && self.forms.length > 0) {
            self.forms.forEach(f => {
              if (f.onSaveComplete) f.onSaveComplete(self, item);
            })
          }
          else if (self.form && self.form.onSaveComplete) self.form.onSaveComplete(self, item);
          if (((typeof self.form.closeBladeOnSave == "undefined" && self.parent.detailComponents.length == 1) || self.form.closeBladeOnSave) && self.parent && self.parent.closeBlade)
            self.parent.closeBlade();
        }, error: function (error) {
          self.loading = false;
          self.nestedNavigationService.loading = false;

          self.messageService.error((error && error.error ? error.error : ''), 'Could not save. ');
        }
      });
  }
  public addNew() {
    let self: MfGeneratedFormComponent = this;
    self._newItem = true;
    self.entityData = {};
    self._forms.forEach(form => {
      form.fields.forEach(field => {
        if (typeof field.default != "undefined") {
          if ({}.toString.call(field.default) === '[object Function]') {
            self.entityData[field.field] = field.default(self)
          }
          else self.entityData[field.field] = field.default;
        }
      })

    });
    if (typeof self.parent.formIndex != 'undefined')
      self.parent.selectedMenuItemIndex = 0;
    self._forms.forEach(form => { if (form.onLoaded) form.onLoaded(self, self.entityData); });
    if (self.entityOptions && self.entityOptions.onLoaded) self.entityOptions.onLoaded(self, self.entityData);
    if (self.entityOptions && self.entityOptions.form && self.entityOptions.form.loadOnNew) self.loadEntity(true, true);
  }
  public delete() {
    let self: MfGeneratedFormComponent = this;
    let dialogRef = self.dialogService.open(MfControlPopupComponent, {
      data: { title: 'Are you sure you want to delete?', actions: ['Delete', 'Cancel'], actionColors: ['warn', 'default'] },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'Delete') {
        self.loading = true;
        let deleteEndPoint: IDataEndPoint =
          self.entityOptions && self.entityOptions.endPoints && self.entityOptions.endPoints.delete
            ? self.entityOptions.endPoints.delete
            : self.form && self._form.endPoints && self._form.endPoints.delete
              ? self._form.endPoints.delete
              : null;
        if (deleteEndPoint)
          self.apiService.exec({
            endPoint: deleteEndPoint,
            context: self,
            success: function (data) {
              self.loading = false;
              if (self.parent && self.parent.onBladeSave)
                self.parent.onBladeSave(self);


              self.reset();
              if (self.parent && self.parent.loadData)
                self.parent.loadData();
              if (self.parent && self.parent.selectedItem)
                self.parent.selectedItem = null;

              self.parent.refreshRelatedLists(self.entityOptions.name, self.entityId);
              self.messageService.success('Removed successfully', 'Action');
              self.cancel();
            }, error: function (error) {
              self.loading = false;
              self.messageService.error((error && error.error ? error.error : ''), 'Could not remove');
            }
          });
      }
    });

  }
  public async anyControlBlockingSave(displayErrors?) {
    var _th = this;
    var valid = true;
    this._formFields.forEach(o => {
      if (o.blockSaving) {
        if (displayErrors)
          o.requiredAnimation = true;
        valid = false;
      }
      else {
        if (displayErrors)
          o.requiredAnimation = false;
      }
    });

    if (displayErrors) {
      setTimeout(function () {
        _th._formFields.forEach(o => {
          o.requiredAnimation = false;
        })
      }, 1000)
      if (!valid)
        this.messageService.error('Processing...', 'Please wait for processing to finish before saving');
    }
    return valid;
  }

  public anyValidationIssues() {
    var issues = false;
    var self = this;
    let formFields: Array<FormBuilderControl> = new Array<FormBuilderControl>();
    if (self.fieldGroups) {
      self.fieldGroups.forEach(fg => {
        if (!fg.hidden && (!fg.show || fg.show(null, self.entityData))) {
          formFields = formFields.concat(fg.formFields);
        }
        else {
          fg.formFields.forEach(o => {
            o.requiredAnimation = false;
            o.validationFailed = false;
          })
        }
      })
    }
    else {
      formFields = self._formFields;
    }

    formFields.forEach(o => {
      if (o.fieldOptions) {
        if (o.fieldOptions.validationMessage == null || o.fieldOptions.validationMessage == "" || typeof o.fieldOptions.validationMessage == "undefined") {
          o.requiredAnimation = false;
        }
        else if (o.fieldOptions.show == undefined || (o.fieldOptions.show && o.fieldOptions.show(self.entityData, self.authService, self))) {
          issues = true;
          o.requiredAnimation = true;
        }
      }
    });
    setTimeout(function () {
      self._formFields.forEach(o => {
        o.requiredAnimation = false;
      })
    }, 1000);
    return issues;
  }

  public readOnlyField(formField) {
    if ({}.toString.call(formField.fieldOptions.readOnly) === '[object Function]') {
      let test: any = formField.fieldOptions.readOnly;
      return test(this.entityData, this, formField)
    }
    else return formField.fieldOptions.readOnly;
  }

  public validateRequiredFields() {
    debugger;
    let _th: MfGeneratedFormComponent = this;
    let valid: boolean = true;
    let formFields: Array<FormBuilderControl> = new Array<FormBuilderControl>();
    if (_th.fieldGroups) {
      _th.fieldGroups.forEach(fg => {
        if (!fg.hidden && (!fg.show || fg.show(null, _th.entityData))) {
          formFields = formFields.concat(fg.formFields);
        }
        else {
          fg.formFields.forEach(o => {
            o.requiredAnimation = false;
            o.validationFailed = false;
          })
        }
      })
    }
    else {
      formFields = _th._formFields;
    }


    formFields.forEach(o => {
      var isRequired = false;
      var anyRequired: any = o.fieldOptions.required;
      var field: string = o.fieldOptions.dbField ? o.fieldOptions.dbField : o.field;
      if ({}.toString.call(anyRequired) === '[object Function]')
        isRequired = anyRequired(_th.entityData, _th.authService, _th);
      else isRequired = anyRequired;

      if (isRequired && (!o.fieldOptions.show || (o.fieldOptions.show && o.fieldOptions.show(_th.entityData, _th.authService, _th)))
        && (!this.readOnlyField(o))) {
        if ((typeof _th.entityData[field] == 'undefined' || _th.entityData[field] == null || _th.entityData[field].toString().replace(/\s/g, '') === '' || _th.entityData[field] === null || (Object.prototype.toString.call(_th.entityData[field]) === '[object Array]' && _th.entityData[field].length == 0))

        ) {
          if (typeof _th.entityData[field] != 'undefined' && _th.entityData[field] != null && _th.entityData[field].toString().replace(/\s/g, '') === '')
            _th.entityData[field] = '';
          o.requiredAnimation = true;
          o.validationFailed = true;
          valid = false;
        }
        else {
          if (o.fieldOptions && o.fieldOptions.validationMessage) {
            o.requiredAnimation = true;
            o.validationFailed = true;
            valid = false;
          }
          if (o.fieldOptions && o.fieldOptions.minLength) {
            if (_th.entityData[field].length < o.fieldOptions.minLength) {

              //o.fieldOptions.validationMessage = 'Minimum length not satisfied'; // o.fieldOptions.minValueMessage
              o.requiredAnimation = true;
              o.validationFailed = true;
              valid = false;
            } else {
              //o.fieldOptions.validationMessage = null
              o.requiredAnimation = false;
              o.validationFailed = false;
            }
          }
          else {
            o.requiredAnimation = false;
            o.validationFailed = false;
          }
        }
      }
    })

    setTimeout(function () {
      _th._formFields.forEach(o => {
        o.requiredAnimation = false;
      })
    }, 1000)
    return valid;
  }
  public reset() {
    this._formFields.forEach(o => {
      if (o.fieldOptions) {
        o.fieldOptions.validationMessage = null;

      }
    });
    this.formReadonly = false;
    this.entityData = {};
    this._newItem = false;
    this.htmlForm.resetForm();
  }
  public cancel() {
    if (this.dialogRef) {
      this.dialogRef.close('cancel');
      return;
    }
    if (this.parent && this.parent.selectedItem)
      this.parent.selectedItem = null;
    if (this.parent && this.parent.closeBlade)
      this.parent.closeBlade();
  }
  public updateLists() {

  }
  public makeFormReadOnly(readonly) {
    this.formReadonly = readonly;
  }

  public newlyAddedItemLoad() {
    this.newlyAddedItemLoaded = false;
    //Item was created and reloaded

  }
  public ngOnInit() {
    if (this.entityOptions && this.entityOptions.form && this.entityOptions.form.className)
      this.formClass = this.entityOptions.form.className;

    if (this.form && this.form.onInit)
      this.form.onInit(this);
  }
  public ngAfterViewInit() {
    if (this.detailPageComponentTabs && this.detailPageComponentTabs.length > 0) {
      this.buildTabs();
    }
  }
  public ngOnDestroy() {
    while (this._subscriptions.length > 0) this._subscriptions.pop().unsubscribe();
  }
  public getFormControlInstance(fg: FormBuilderControl) {
    if (!this._formFields)
      return;
    var filt = _.filter(this._formFields, o => {
      return o.bindingValue == fg.field
    })
    if (filt.length == 1)
      return filt[0].formControl;
    else return null;
  }

  public navigateToIndex(index, id, startNavIndex?, extraParams?) {
    this.parent.navigateToIndex(index, id, startNavIndex, extraParams);
  }
  public closeBlade() {
    this.parent.closeBlade();
  }
}
